import { SHOP_GIFT_TIME, ShopCatalog, ShopProductIDs } from '../../Config/Shop';
import Core from '../../Core/Core';
import { TGameAreas } from '../../DeltaTracking/ResourceParamBuilder';
import { PurchaseStatus } from '../../SDK/ISDKpayments';
import { Actions } from '../../State/Actions/Actions';
import DateUtils from '../../Utils/DateUtils';
import HudView from '../../View/HudView';
import { HudActions, HudEmitter } from '../Hud/HudEmitter';
import { Manager } from '../Manager';
import { Popup } from '../Popups';
import ResourceTracking from '../Tracking/ResourceTracking';
import ShopTracking, { PurchaseTrackingStage } from '../Tracking/ShopTracking';
import Purchase = FBInstant.Purchase;
import Product = FBInstant.Product;

export class Shop extends Manager {
    private view: HudView;
    private cachedCatalog: Product[];
    private freeProduct: Product;
    private giftShown: boolean = false;

    constructor(view: HudView) {
        super();

        this.view = view;

        this.freeProduct = {
            title: 'Free!',
            productID: ShopProductIDs.FreeGift,
            price: '0',
            priceCurrencyCode: 'EUR',
        };
        HudEmitter.instance.on(HudActions.BUY_PRODUCT, this.handleBuyProduct.bind(this));
    }

    public async addShop() {
        await this.view.createShopPopup(await this.getPlayerCatalog()).then(() => {
            Core.store.dispatch(Actions.shopOpened());
        });
    }

    public async removePopup() {
        await this.view.deleteShopPopup();
    }

    public async consumePurchases(...purchases: Purchase[]) {
        if (!purchases) {
            purchases = await Core.sdk.payments.getPurchases();
        }
        for (const current of purchases) {
            const consume = await Core.sdk.payments.consumePurchase(current.purchaseToken);
            if (consume) {
                const { items } = ShopCatalog[current.productID as ShopProductIDs];
                HudEmitter.instance.emit(HudActions.RECEIVE_REWARDS, items);
            }
        }
    }

    public async handleBuyProduct(product: Product) {
        if (product.productID === ShopProductIDs.FreeGift) {
            ShopTracking.trackGift();
            this.handleFreeGift();
        } else {
            ShopTracking.trackPurchase(product.productID, PurchaseTrackingStage.CLICK);
            HudEmitter.instance.emit(HudActions.SOCIALHUB_START_LOAD_SOCIAL);
            const { purchase: current, status } = await Core.sdk.payments.purchase(
                product.productID
            );
            if (status === PurchaseStatus.Success) {
                ShopTracking.trackPurchase(product.productID, PurchaseTrackingStage.SUCCESS);
                Core.store.dispatch(Actions.savePurchase(current));
                await this.consumePurchases(current);
                // this.view.updateShopCatalog(await this.getPlayerCatalog());
                HudEmitter.instance.emit(HudActions.CLOSE_POPUP, Popup.SHOP);
                ResourceTracking.sendTransactionEvent(product, TGameAreas.MAP);
            } else if (status === PurchaseStatus.Error) {
                ShopTracking.trackPurchase(product.productID, PurchaseTrackingStage.ERROR);
                HudEmitter.instance.emit(HudActions.ADD_POPUP, Popup.PURCHASE_STATUS, 1, status);
            } else {
                ShopTracking.trackPurchase(product.productID, PurchaseTrackingStage.CANCEL);
            }
            HudEmitter.instance.emit(HudActions.SOCIALHUB_STOP_LOAD_SOCIAL);
        }
    }

    private async handleFreeGift() {
        if (Core.sdk.backend && (await Core.sdk.backend.checkConnection())) {
            const timestamp = await Core.sdk.backend.fetchServerTimestamp();
            Core.store.dispatch(Actions.shopGift(timestamp));
        } else {
            Core.store.dispatch(Actions.shopGift()); // will get more gifts if they servertime not available need a better way
        }

        this.view.showFreeGift();
        this.view.updateShopCatalog(await this.getPlayerCatalog());
        if (this.view.mapBottomUi) {
            const sButton = this.view.mapBottomUi.getButton(Popup.SHOP);
            sButton.swapButton('mapui/navi-icon-shop');
        }
    }

    private async getPlayerCatalog() {
        const self = this;
        let timeForFree = false;

        await prepareTime();

        prepareCached();

        const catalog = await this.getCatalog();

        prepareCatalog();

        const productCount = (productID: string) =>
            Core.store.getState().StatePlayer.purchases.filter(x => x.productID === productID)
                .length;
        return catalog.filter(x => {
            const productData = ShopCatalog[x.productID as ShopProductIDs];
            return (
                (!productData.limit || productCount(x.productID) < productData.limit) &&
                (!productData.require || productCount(productData.require) > 0)
            );
        });

        async function prepareTime() {
            if (Core.sdk.backend && (await Core.sdk.backend.checkConnection())) {
                const now = await Core.sdk.backend.fetchServerTimestamp();
                const lastGiftTime = Core.store.getState().StatePlayer.shopGift;
                const timeRemaining = DateUtils.timeRemainingTo(lastGiftTime + SHOP_GIFT_TIME, now);

                timeForFree = lastGiftTime === 0 || timeRemaining <= 0;
            }
        }

        function prepareCached() {
            if (timeForFree !== self.giftShown) {
                self.cachedCatalog = null;
            }
            self.giftShown = timeForFree;
        }

        function prepareCatalog() {
            const free = catalog.find(p => p.productID === ShopProductIDs.FreeGift);
            const smIndex = catalog.indexOf(
                catalog.find(p => p.productID === ShopProductIDs.CoinsS)
            );

            if (smIndex !== null && smIndex !== undefined && !free && timeForFree) {
                catalog[smIndex] = self.freeProduct;
            }
        }
    }

    private async getCatalog() {
        if (!this.cachedCatalog) {
            HudEmitter.instance.emit(HudActions.SOCIALHUB_START_LOAD_SOCIAL);
            const catalog = await Core.sdk.payments.getCatalog();
            this.cachedCatalog = catalog.filter(x => ShopCatalog[x.productID as ShopProductIDs]);
            HudEmitter.instance.emit(HudActions.SOCIALHUB_STOP_LOAD_SOCIAL);
        }
        return this.cachedCatalog;
    }
}
